export const getFileType = (filename) => {
  const extension = filename.split('.').pop()
  return extension
}
